import {CHANGE_SIDE} from "../constants/action-types";

const getSideIndex = (metaDesigns, side) => {
  return metaDesigns.reduce(
    (acc, item, i) => (item.side === side ? i : acc),
    0
  );
};
const getSideInfo = (side, designs) => {
  return designs.find((design) => {
    return design.side === side;
  });
};
export const changeSide = (side) => (dispatch, getState) => {
  const {
    designs,
    condition: {design: prevDesign, side: prevSide},
    product: {
      meta: {designs: metaDesigns}
    }
  } = getState();

  const prevSideIndex = getSideIndex(metaDesigns, prevSide);
  const nextSideIndex = getSideIndex(metaDesigns, side);
  const {dimensions, dpi} = getSideInfo(side, metaDesigns);

  dispatch({
    type: CHANGE_SIDE,
    payload: {
      prev: {
        side: prevSide,
        index: prevSideIndex,
        design: prevDesign ? prevDesign : {}
      },
      next: {
        side,
        index: nextSideIndex,
        design: designs[nextSideIndex].design,
        dimensions,
        dpi
      }
    }
  });
};
